$('.footer-bottom-line').find('div').eq(1).html('');